import { render, staticRenderFns } from "./PopupAddMealDislikes.vue?vue&type=template&id=3d2e771a&scoped=true"
import script from "./PopupAddMealDislikes.vue?vue&type=script&lang=js"
export * from "./PopupAddMealDislikes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2e771a",
  null
  
)

export default component.exports